import { useTheme } from "@mui/material";
import type { Feature } from "geojson";
import { GeoJSON } from "react-leaflet";

interface Props {
  feature: Feature;
}

export function SelectedCaseFeaturePreview(props: Props) {
  const { feature } = props;
  const { palette } = useTheme();

  return (
    <GeoJSON
      key={feature.id}
      data={feature}
      style={{ color: palette.primary.main, opacity: 1, fillOpacity: 0.2 }}
      pmIgnore={true}
    />
  );
}
